import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import ImageBackground from '@hfe/max-imagebackground';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import Sensor from '@max/mbc-sensor';
import { TaskButtonState } from '../../types/shared';
import './index.scss';
// R007：弹窗标题为固定文案（PRD 明确不提供弹窗标题配置）
const MODAL_TITLE = '完成任务 加速解锁免单卡';
const EMPTY_TEXT = '暂无任务，敬请期待';
const CLOSE_ICON = 'https://img.meituan.net/makerjiulv/290a1bf2ffe5334f83dd948c7e4187f2622.png';
// R007：弹窗默认底色（设计稿 #eff7ff，运营未配置渐变时使用）
const DEFAULT_BG_COLOR = '#eff7ff';
// R007：未完成态按钮横向玫红渐变（设计稿 0519-组件优化 5 实测：左 #f11957 → 右 #fb2173）
const UNFINISHED_BTN_COLORS = ['#f11957', '#fb2173'];
function TaskListModal(props) {
    const { visible, taskCenterConfig, taskList, onClose, onTaskClick, onItemExpose } = props;
    const bgStartColor = taskCenterConfig?.bgStartColor || DEFAULT_BG_COLOR;
    const bgEndColor = taskCenterConfig?.bgEndColor || DEFAULT_BG_COLOR;
    return <TopView>
      <ModalBaseContainer visible={visible} type="slide" onMaskPress={onClose} maskStyle={{
        opacity: 0.8
    }} maskAnimationIn={{
        opacity: [0, 0.8],
        duration: 300
    }} maskAnimationOut={{
        opacity: [0.8, 0],
        duration: 300
    }}>
        <View className="task-list-modal">
          <LinearGradient className="task-list-modal__background" colors={[bgStartColor, bgEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}/>
          
          <View className="task-list-modal__header">
            {taskCenterConfig?.headerImage ? <Image className="task-list-modal__header-image" source={{
        uri: taskCenterConfig.headerImage
    }}/> : null}
            <Button className="task-list-modal__close-btn" onPress={onClose}>
              <Image className="task-list-modal__close-icon" source={{
        uri: CLOSE_ICON
    }}/>
            </Button>
          </View>
          
          <View x-if={taskList.length === 0} className="task-list-modal__empty">
            <Text className="task-list-modal__empty-text">{EMPTY_TEXT}</Text>
          </View>
          <View x-if={taskList.length > 0} className="task-list-modal__list-wrapper">
            <ScrollView className="task-list-modal__scroll" showsVerticalScrollIndicator={false}>
              <View className="task-list-modal__list">
                {taskList.map((task, index) => <Sensor key={task.taskId} once onAppear={() => onItemExpose(task)}>
                    <View className="task-list-modal__item">
                      <View className="task-list-modal__item-row">
                        {task.iconImage ? <Image className="task-list-modal__item-icon" source={{
        uri: task.iconImage
    }}/> : null}
                        <View className="task-list-modal__item-main">
                          
                          <Text className="task-list-modal__item-title" numberOfLines={1}>{task.title}</Text>
                          <Text className="task-list-modal__item-progress">{task.progressText}</Text>
                        </View>
                        <Button className="task-list-modal__item-btn-wrapper" onPress={() => onTaskClick(task)}>
                          {task.buttonImage ? <ImageBackground className="task-list-modal__item-btn-image" source={{
        uri: task.buttonImage
    }} resizeMode="stretch">
                              <Text className="task-list-modal__item-btn-image-text">{task.buttonText}</Text>
                            </ImageBackground> : <View className={`task-list-modal__item-btn task-list-modal__item-btn--${task.buttonState}`}>
                              {task.buttonState === TaskButtonState.UNFINISHED ? <LinearGradient className="task-list-modal__item-btn-gradient" colors={UNFINISHED_BTN_COLORS} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }}/> : null}
                              <Text className={`task-list-modal__item-btn-text task-list-modal__item-btn-text--${task.buttonState}`}>
                                {task.buttonText}
                              </Text>
                            </View>}
                        </Button>
                      </View>
                      {index < taskList.length - 1 ? <View className="task-list-modal__item-divider"/> : null}
                    </View>
                  </Sensor>)}
                <View className="task-list-modal__list-footer"/>
              </View>
            </ScrollView>
          </View>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(TaskListModal);
